module.exports = __webpack_public_path__ + "static/icon_commercial_orange-a697d5e8a24de8a1c99f903157863556.png";